import React from "react";

// creates two variables
const AuthUserContext = React.createContext(null);

export default AuthUserContext;
